export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const KEY = 'a2ee091e-b1c3-4654-842c-964184400f38';
export const TIME_OUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
